import React from "react";
import { Card, Row, Spinner } from "react-bootstrap";

function AvailablePtoPanel(props) {
    return (
      <Card className="total-balance-card popout-element">
        <Card.Body>
          <Row className="justify-content-center">
            {props.isLoading ? (
              <Spinner animation="border" size="sm" style={{ marginLeft: "10px", marginRight: "10px" }} />
            ) : (
              <span className="available-hours-total-balance">
                PTO Available: {props.data.toFixed(2)} Hours
              </span>               
            )}
          </Row>
        </Card.Body>
      </Card> 
    );
}

export default AvailablePtoPanel;
